var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryPresence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_186874",
    "data-name": "Group 186874",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.191,
    height: 20,
    viewBox: "0 0 19.191 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_186873",
    "data-name": "Group 186873",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75275",
    "data-name": "Path 75275",
    d: "M28.624,10.257a.586.586,0,0,1,0-.518l.746-1.526a1.736,1.736,0,0,0-.749-2.306l-1.5-.8a.586.586,0,0,1-.3-.419l-.293-1.673a1.736,1.736,0,0,0-1.961-1.425l-1.682.238a.586.586,0,0,1-.493-.16L21.166.491a1.736,1.736,0,0,0-2.424,0L17.521,1.672a.586.586,0,0,1-.493.16l-1.682-.238A1.736,1.736,0,0,0,13.386,3.02l-.293,1.673a.586.586,0,0,1-.3.419l-1.5.8a1.736,1.736,0,0,0-.749,2.306l.746,1.526a.586.586,0,0,1,0,.518l-.746,1.526a1.736,1.736,0,0,0,.749,2.306l1.5.8a.586.586,0,0,1,.3.419l.293,1.673A1.735,1.735,0,0,0,15.1,18.419a1.784,1.784,0,0,0,.25-.018l1.682-.238a.586.586,0,0,1,.493.16L18.742,19.5a1.736,1.736,0,0,0,2.424,0l1.221-1.181a.587.587,0,0,1,.493-.16l1.682.238a1.736,1.736,0,0,0,1.961-1.425l.293-1.673a.586.586,0,0,1,.3-.419l1.5-.8a1.736,1.736,0,0,0,.749-2.306ZM17.647,4.807a2.115,2.115,0,1,1-2.115,2.115A2.117,2.117,0,0,1,17.647,4.807Zm-1.092,9.4a.577.577,0,0,1-.816-.816l7.613-7.613a.577.577,0,1,1,.816.816Zm5.706.977a2.115,2.115,0,1,1,2.115-2.115A2.117,2.117,0,0,1,22.261,15.189Z",
    transform: "translate(-10.359 0.002)",
    fill: "#7d96ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryPresence);
export default __webpack_public_path__ + "static/media/categoryPresence.df4756937b965091c4f86c4d52037d2d.svg";
export { ForwardRef as ReactComponent };